import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarningOrange = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.5,
			cy: 12.8447,
			r: 12,
			fill: "#FFB800"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.4941,
			cy: 9.66699,
			r: .75,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7441 11.373H12.7441C13.0203 11.373 13.2441 11.5969 13.2441 11.873V17.373H11.7441V11.373Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.4395,
			y: 11.373,
			width: 1.87793,
			height: .697266,
			fill: "white"
		})
	]
});
export default SvgWarningOrange;
